/* tslint:disable:max-line-length */
/// <reference path='../../core/services/resource.service.ts'/>
/// <reference path='../../core/services/resource.service.ts'/>

namespace Search {

    type BD4Travel = TR.BD4Travel;
    class Tab {
        maxAge: number;
        multiRoomDisabled: boolean;
        constructor(
            public id: number,
            public type: UnifiedSearchType | null,
            public name: string,
            options?
        ){
            angular.extend(this, options);
        }
    }

    class Search {
        tab: Tab;
        tabs:any = {
            1: new Tab(1, UnifiedSearchType.Holidays, 'holidays', { maxAge: TRPCONFIG.Domain.MaxChildAgeForHolidays }),
            2: new Tab(2, UnifiedSearchType.Hotels, 'hotels'),
            3: new Tab(3, UnifiedSearchType.Flights, 'flights', { maxAge: TRPCONFIG.Domain.MaxChildAgeForFlights, multiRoomDisabled: true }),
            4: new Tab(4, null, 'transfers', ''),
            5: new Tab(5, null, 'cruises', ''),
            6: new Tab(6, null, 'marhaba', ''),
            7: new Tab(7, null, 'holidayDeals', ''),
            8: new Tab(8, null, 'insurance', '')
        };
        model: UnifiedSearchModel;
        allowNoDatesYet = true;
        overrideAllowNoDatesYet;
        currencyOptions = TRPCONFIG.Domain.CurrencyOptions.split('|');
        cabins;
        enabledDates;
        preselectTab: string;
        showTabs: boolean;
        includedTabIds: number[];
        supportedTabIds: any;
        fid: string;
        clearFormInAgentMode: string;
        hiddenQueryString: string;
        airlines: Airline[];
        expandedOptions = false;
        trackDefaultParameters: string;
        isFlexibleTripType: boolean;
        disableResetOptions;

        constructor (
            private $route: ng.route.IRouteService,
            private $q: ng.IQService,
            private broker: Core.Broker,
            private searchUnitService: SearchUnitService,
            private unifiedSearchService: UnifiedSearchService,
            private $scope,
            private destinationService,
            private searchQueryString: SearchQueryString,
            private $timeout: ng.ITimeoutService,
            private bd4travel: BD4Travel,
            private preferences
        ) {
            if (TRPCONFIG.Domain.PassThroughSearchToIntegratedSearch) {
                return;
            }

            this.model = this.unifiedSearchService.getDefaultModel();
            this.cabins = searchUnitService.getCabinOptions();

            this.updateNoDatesYet();
            this.airlines = searchQueryString.allAirlines;

            this.supportedTabIds = _.chain(TRPCONFIG.Domain.SupportedProductNames)
                .map(name => this.findTabId(name))
                .filter(tabId => !!tabId)
                .value();

            let intersection =
                this.includedTabIds ? _.intersection(this.supportedTabIds, this.includedTabIds) : this.supportedTabIds;
            this.showTabs = intersection.length > 1;

            let tabIdToSelect = this.getPreselectTabId();

            this.selectTab(tabIdToSelect);

            const clearForm = TRPCONFIG.Domain.isAgentMode && this.clearFormInAgentMode === 'true';
            if (!clearForm) {
                this.unifiedSearchService.getQueryStringValues(this.hiddenQueryString).then(queryStringValues => {
                    this.unifiedSearchService
                        .prepopulateModel(this.model, queryStringValues)
                        .then(m => {
                            if (this.trackDefaultParameters) {
                                this.bd4travel.trackInitialParameters(m, this.trackDefaultParameters);
                            }
                        });

                    this.expandedOptions = (() => {
                        if (!angular.isUndefined(queryStringValues.expandedOptions)) {
                            return queryStringValues.expandedOptions;
                        }
                        if (TRPCONFIG.Domain.PrefilterAirlineEnabled && this.model.airlines && this.model.airlines.length) {
                            return true;
                        }
                        if (TRPCONFIG.Domain.PrefilterDirectFlightsEnabled && this.model.prefilterDirectFlights) {
                            return true;
                        }
                        return false;
                    })();

                    if (queryStringValues.autoSearch) {
                        if ( queryStringValues.sortOrder ) {
                            this.preferences.setHotelSortOrder( parseInt(queryStringValues.sortOrder,10) );
                        }
                        this.$timeout(() => this.search(true), 1000);
                    }
                });
            }

            this.$scope.$watchCollection(() => this.model.destination, val => {
                //Ensure that destination is always an array.
                if (val && angular.isUndefined(val.length)) {
                    val = this.model.destination = [val];
                }

                if (val && val[0]) {
                    //This call mutates the destination:
                    this.destinationService.getDetails(val[0]).then(dest => {
                        broker.publish('destinationChanged', dest);
                        this.loadOutboundDates(this.model.airports, dest);
                    });
                }
                let searchLookupType = val && val[0] && val[0].searchLookupType;
                this.updateNoDatesYet(searchLookupType);
            });

            this.$scope.$watchCollection(() => this.model.airports,
                val => this.loadOutboundDates(val, this.model.destination));

            if(!_.isEmpty(TRPCONFIG.Domain.FixedDepartureAirportOptions)) {
                this.broker.subscribe('holidaySearch', 'departureAirportsChanged', (v) => {

                    let currentAirports = this.model.airports.reduce((acc, airport) => {
                        return acc[airport.Code] = airport;
                    }, {});
                    let updatedAirports = v.data.Code.split(',').map(code => currentAirports[code] || ({Code: code}));
                    this.model.airports = updatedAirports;
                });
            }

            this.broker.subscribe('holidaySearch', 'RegionalContextSelected', () => {
                //reset the preferences when switching between POS
                this.model.airports = [];
                this.unifiedSearchService.saveSearchModel(this.model);
            });
        };

        selectTab(tabId: number): void {
            this.$scope.$broadcast('flash:hide');
            this.tab = this.tabs[tabId];
            if(this.$route.current && this.$route.current['$$route']) {
                this.$route.current['$$route'].area = this.tab.name;
            }
            this.loadOutboundDates(this.model.airports, this.model.destination);
        };

        includeTab(tabId: number): boolean {
            const isIncluded = !this.includedTabIds || !this.includedTabIds.length || this.includedTabIds.indexOf(tabId) >= 0,
                isSupported = !this.supportedTabIds || !this.supportedTabIds.length || this.supportedTabIds.indexOf(tabId) >= 0;
            return isIncluded && isSupported;
        }

        private getPreselectTabId(): number {
            let tabId = this.findTabId(this.preselectTab);
            if (tabId && this.includeTab(tabId)) {
                return tabId;
            }
            return _.find(this.tabs, (t:Tab) => this.includeTab(t.id)).id;
        }

        private findTabId(tabNameOrNumber: string): number | undefined {
            if (!tabNameOrNumber) {
                return;
            }
            let tabId = parseInt(tabNameOrNumber, 10);
            if (tabId > 0 && this.tabs[tabId]) {
                return tabId;
            }
            tabNameOrNumber = (tabNameOrNumber + '').toLowerCase();
            let tab = _.find(this.tabs, (t: any) => t.name.toLowerCase() === tabNameOrNumber);
            if (tab) {
                return tab.id;
            }
        }

        private updateNoDatesYet(searchLookupType?: string) {
            if (this.overrideAllowNoDatesYet) {
                this.allowNoDatesYet = this.overrideAllowNoDatesYet === 'true';
            } else {
                this.allowNoDatesYet = !searchLookupType || searchLookupType === 'hotels';
            }
            if (!this.allowNoDatesYet) {
                this.model.noDatesYet = false;
            }
        }

        search(isAutoSearch: boolean) {
            return this.destinationService.getDetails(this.model.destination[0]).then(dest => {
                return this.loadOutboundDates(this.model.airports, dest).then(() => dest);
            }).then(dest => {
                //creating a copy of the model to use to run a search.
                const destination = _.assign({}, this.model.destination[0], dest);
                const model = <UnifiedSearchModel>_.assign(<UnifiedSearchModel>{}, this.model, {destination: [destination]});

                return this.unifiedSearchService.launchSearch(model,
                    this.tab.type || UnifiedSearchType.Holidays,
                    this.fid,
                    !isAutoSearch,
                    false,
                    false
                );
            });
        };

        loadOutboundDates(airports, destination) {
            const getRequest = () => {
                if (this.tab.id !== 1 && this.tab.id !== 3) {
                    return this.$q.when(null);
                }
                if (!airports || !airports.length) {
                    return this.$q.when(null);
                }
                let DepartureAirportCodes = _.map(airports, (a: any) => a.Code);

                destination = destination && destination[0] || destination;
                let codes = destination && (destination.Code || destination.DestinationAirports);
                let DestinationAirportCodes = codes && codes.split(',');
                if (DestinationAirportCodes && DestinationAirportCodes.length) {
                    return this.$q.when({
                        DepartureAirportCodes,
                        DestinationAirportCodes
                    });
                }

                return this.$q.when(null);
            };
            return getRequest()
                .then(r => this.searchUnitService.loadOutboundDates(r))
                .then(outboundDates => {
                    this.enabledDates = outboundDates;
                });
        }

    }

    angular
        .module('search')
        .directive('search', (): ng.IDirective => {
            return {
                scope: {},
                controller: Search,
                controllerAs: 'search',
                bindToController: {
                    moreOptions: '=',
                    preselectTab: '@',
                    overrideAllowNoDatesYet: '@',
                    includedTabIds: '=?',
                    fid: '=?',
                    clearFormInAgentMode: '@',
                    hiddenQueryString: '@',
                    trackDefaultParameters: '@',
                    resetDuration: '=?',
                    isFlexibleTripType: '=?',
                    disableResetOptions: '@?'
                },
                templateUrl: TRPCONFIG.Domain.PassThroughSearchToIntegratedSearch
                    || new RegExp(/[a-z]{3,4}:[a-z]{3,4}/g).test(TRPCONFIG.Domain.RedirectTemplates)
                ? 'partials/search/integrated'
                : 'partials/search/search',
                replace: true,
                restrict: 'E',
            };
        });
}
